export const OrderLine = ({ item, number }) => {
  const subtotalHT = item.price * item.quantity
  const subtotalTTC = parseFloat(
    (subtotalHT + item.totalVAT * item.quantity).toFixed(2),
  )

  return (
    <tr className='text-center'>
      <td>{number}</td>
      <td>{item.productName}</td>
      <td>{item.quantity}</td>
      <td>{item.price}</td>
      <td>{item.size ? item.size : 'N/A'}</td>
      <td>{item.vatCategory}</td>
      <td>{item.totalVAT}</td>
      <td>{subtotalHT.toFixed(2)}</td>
      <td>{subtotalTTC.toFixed(2)}</td>
    </tr>
  )
}
